import React, { FunctionComponent } from "react";
import { Modal } from "react-bootstrap";

type OwnProps = {
  showModal?: boolean;
  onHide: () => any;
};

type Props = OwnProps;

const TrackInterventionModal: FunctionComponent<Props> = (props) => {
  return (
    <Modal
      show={props.showModal}
      animation={false}
      size="lg"
      centered
      backdropClassName="customDarkModalBackdrop in"
      onHide={props.onHide}
    >
      <Modal.Header closeButton className={"purpleModalHeader"}>
        <Modal.Title className="modalTitle">Track Intervention</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Track interventions by logging student progress toward goals and recording the 
          fidelity of implementation.
        </p>
        <p className="text-center">
          All tracking actions are managed in the <strong><i>Reading/Behavior Intervention Groups</i></strong> menu, 
          where each group’s details are organized in a dedicated workspace.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default TrackInterventionModal;
